import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";

@Component({ name: "ModuleLandingPageActionList" })
export default class ModuleLandingPageActionList extends Vue {
    get navigationContext(): any {
        return this.$store.getters["navigationStore/navigationContext"]
    }

    get itemIdMaster(): any {
        return this.$store.getters["itemStore/itemIdMaster"];
    }

    public async copyUrl() {
        let url = (await Axios.post("/dataweb/api/landingpage/getlandingpageUrl", { idMaster: this.itemIdMaster }, { headers: {} })).data;
        navigator.clipboard.writeText(url);
        this.$store.dispatch("toastStore/onAddToast", { message: "Url copiato negli appunti", type: "Success" });
    }
};